module.exports = __webpack_public_path__ + "static/media/Rah_Ghaleds_Ruiner.6ff36e75.md";